import {
	motion,
} from 'motion/react'
import type {
	JSX,
} from 'react'
import {
	memo,
} from 'react'

import {
	LoaderDot,
	LoaderRoot,
} from './loader.styles'
import type {
	ILoaderProps,
} from './loader.types'

const MotionDot = motion.create(LoaderDot)

const dotVariants = {
	initial: {
		y:       0,
		opacity: 0.5,
	},
	animate: {
		y:       [0, -10, 0],
		opacity: [0.5, 1, 0.5],
	},
}

export const Loader = memo((props: ILoaderProps): JSX.Element => {
	const {
		size = 'medium',
	} = props

	return (
		<LoaderRoot size={size}>
			{[0, 1, 2].map((index) => {
				return (
					<MotionDot
						key={index}
						size={size}
						initial='initial'
						animate='animate'
						variants={dotVariants}
						transition={{
							duration:   0.6,
							repeat:     Infinity,
							ease:       'easeInOut',
							delay:      index * 0.15,
						}}
					/>
				)
			})}
		</LoaderRoot>
	)
})

Loader.displayName = 'Loader'
